import React, { Component } from 'react'
import './style.css'
import {Button} from '@material-ui/core'
import event1 from '../../assets/image/event1.jpg'
import NoImage from '../../assets/image/no_image.png'
import moment from 'moment'
import {groupBy} from 'lodash'

export default class grid extends Component {
    renderCategory=(id)=>{
        switch (id) {
            case 1:
                return 'Mega Seminar'
                // break;
            case 2:
                return 'Public Workshop'
            case 3:
                return 'Webinar'
            case 4:
                return 'Blended learning'
            default:
                break;
        }
    }
    renderCard=()=>{

        const {data}=this.props
        
        data.sort((a,b)=>(a.webEvent.categoryId>b.webEvent.categoryId)?1:-1)
        let map=data.map((event,i)=>{
            
            if(i<=2){
                // console.log('object', event)
                return(
                    <div className='grid2-container'>
                    <div key={i}  style={{display:'flex',flexDirection:'column'}} onClick={()=>window.location.assign(`https://content.gmlperformance.com/event/${event.webEvent.slug}`)}>
                        <div className='grid2-box-img-overlay'>
                            <img src={event.thumbnailURL!==null?event.thumbnailURL:NoImage} className='grid3-box-img'/>
                        </div>
                        <div className='grid2-box-content'>
                            <div style={{display:'flex',justifyContent:'space-between'}}>
                            {data.webEvent.fromDate===data.webEvent.toDate?
                            <h3>{moment(data.webEvent.fromDate).format('D MMM YYYY')}</h3>
                            :
                            <h3>{moment(data.webEvent.fromDate).format('D MMM')} - {moment(data.webEvent.toDate).format('D MMM YYYY')}</h3>
                            }
                                <h3 >{this.renderCategory(event.webEvent.categoryId)}</h3>
                            </div>
                            <h1>{event.webEvent.title.substring(0,55)}...</h1>

                            <p>{event.webEvent.intro}</p>
                            <div className='grid2-footer'>
                            <Button style={{textTransform:'none',fontWeight:'bold',padding:0}} color="primary" onClick={()=>window.location.assign(`https://content.gmlperformance.com/event/${event.webEvent.slug}`)}>Read more </Button>
                            </div>
                        </div>
                    </div>
                    </div>
                )
            }else{
                // console.log('hello', event)
                return(
                    <div className='grid2-small'>
                    <div className='grid2-subheadline' key={i}  onClick={()=>window.location.assign(`https://content.gmlperformance.com/event/${event.slug}`)}>
                    <div className='show-mobile type-event'>
                            <p >{this.renderCategory(event.webEvent.categoryId)}</p>
                        </div>
                     <div className='grid2-overlay-small'>
                        <img src={event.thumbnailURL!==null?event.thumbnailURL:NoImage} alt="event" className="grid2-img-box-small"  />
                        
                        <div className='card'>
                                <div style={{display:'flex',justifyContent:'space-between'}}>
                                    {data.webEvent.fromDate===data.webEvent.toDate?
                                    <h6>{moment(data.webEvent.fromDate).format('D MMM YYYY')}</h6>
                                    :
                                    <h6>{moment(data.webEvent.fromDate).format('D MMM')} - {moment(data.webEvent.toDate).format('D MMM YYYY')}</h6>
                                    }
                                   
                                    <h6 className='hidden-desktop'>{this.renderCategory(event.webEvent.categoryId)}</h6>
                                </div>
                                <h3>{event.webEvent.title.substring(0,50)}...</h3>
                                <div className='grid2-footer'>
                                    <Button style={{textTransform:'none',fontWeight:'bold',padding:0}} color="primary" onClick={()=>window.location.assign(`https://content.gmlperformance.com/event/${event.webEvent.slug}`)}>Read more </Button>
                                </div>
                        </div>
                    </div>
                </div>
                </div>
                )
            }
        })
        return map
    }
    render() {

        let headline=[]
        let new_headline=[]
        let subheadline=[]
        let event=[]
        this.props.data.map((data,i)=>{
            if(data.webEvent.categoryId===1){
                headline.push(data)
            }else{
                subheadline.push(data)
            }
        })
        
        subheadline.map((data,i)=>{
            if(headline.length<=4){
                headline.push(data)
                subheadline=subheadline.filter((dataq,index)=>{
                    return data.webEvent.id!==dataq.webEvent.id
                })
                // console.log('headeline,subheadline', headline.length,subheadline,i)
                // console.log('qw', headline.length,subheadline,i)
                // if(subheadline.length<3){
                //     subheadline.splice(0,1)

                // }else{
                //     console.log('subheadline', subheadline)
                //     subheadline.splice(i,1)

                // }

            }
        })
        return (
            <div>
               
                {/* <div className='grid2-headline'>
                        {headline.map((headline,i)=>(
                            <div className='overlay' key={i}  onClick={()=>window.location.assign(`${headline.link}/${headline.slug}`)}>
                                <img src={headline.img} className='grid2-headline-image'/>
                                <div className='grid2-caption'>
                                    <div style={{display:'flex',justifyContent:'space-between'}}>
                                        <h3>{headline.subtitle}</h3>
                                        <h3 >{headline.type}</h3>
                                    </div>
                                    <br/>
                                    <h1>{headline.title.substring(0,70)}...</h1>
                                    <br/>
                                    <p>{headline.preview}</p>
                                    <div className='grid2-footer'>
                                    {headline.footer}
                                    </div>
                                    
                                </div>
                            </div>
                        ))}
                </div> */}
                <div className='grid2-container'>
                    {headline.map((data,i)=>(
                        <div key={i}  style={{display:'flex',flexDirection:'column'}} onClick={()=>window.location.assign(`https://content.gmlperformance.com/event/${data.webEvent.slug}`)}>
                        <div className='grid2-box-img-overlay'>
                            <img src={data.thumbnailURL!==null?data.thumbnailURL:NoImage} className='grid3-box-img'/>
                        </div>
                        <div className='grid2-box-content'>
                            <div style={{display:'flex',justifyContent:'space-between'}}>
                                <h3>{moment(data.webEvent.fromDate).format('D MMM')} - {moment(data.webEvent.toDate).format('D MMM YYYY')}</h3>
                                <h3 >{this.renderCategory(data.webEvent.categoryId)}</h3>
                            </div>
                            <h1>{data.webEvent.title.length>72?`${data.webEvent.title.substring(0,72)}...`:data.webEvent.title}</h1>

                            <p>{data.webEvent.intro}</p>
                            <div className='grid2-footer'>
                            <Button variant='contained' style={{textTransform:'none',fontWeight:'bold',padding:0}} color="primary" onClick={()=>window.location.assign(`https://content.gmlperformance.com/event/${data.webEvent.slug}`)}>Detail</Button>
                            </div>
                        </div>
                    </div>
                    ))}
                    
                </div>
               <br/>
                    <div className='grid2-small'>
                    {subheadline.length>0&&subheadline.map((subheadline,i)=>(
                        <div className='grid2-subheadline' key={i}  onClick={()=>window.location.assign(`https://content.gmlperformance.com/event/${subheadline.webEvent.slug}`)}>
                            <div className='show-mobile type-event'>
                                    <p >{this.renderCategory(subheadline.webEvent.categoryId)}</p>
                                </div>
                             <div className='grid2-overlay-small'>
                                <img src={subheadline.thumbnailURL!==null?subheadline.thumbnailURL:NoImage} alt="event" className="grid2-img-box-small"  />
                                
                                <div className='card'>
                                        <div style={{display:'flex',justifyContent:'space-between'}}>
                                            <h6>{moment(subheadline.webEvent.fromDate).format('D MMM')} - {moment(subheadline.webEvent.toDate).format('D MMM YYYY')}</h6>
                                            <h6 className='hidden-desktop'>{this.renderCategory(subheadline.webEvent.categoryId)}</h6>
                                        </div>
                                        <h3>{subheadline.webEvent.title.length>90?`${subheadline.webEvent.title.substring(0,90)}...`:subheadline.webEvent.title}</h3>
                                        <div className='grid2-footer'>
                                            <Button variant='contained' style={{textTransform:'none',fontWeight:'bold',padding:0}} color="primary" onClick={()=>window.location.assign(`https://content.gmlperformance.com/event/${subheadline.webEvent.slug}`)}>Detail</Button>
                                        </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    </div>
            </div>
        )
    }
}
